// extracted by mini-css-extract-plugin
module.exports = {"othersWrapper":"ad-service-module__othersWrapper__2apgv"};